import { observer } from 'mobx-react-lite';
import { Divider, RootContainer } from '../common';
import { AgentBehaviour } from './AgentBehaviour';
import { AgentIdentity } from './AgentIdentity';

export const AgentDetails = observer(() => {
    return (
        <RootContainer>
            <AgentIdentity />
            <Divider />
            <AgentBehaviour />
        </RootContainer>
    );
});
